<template>
  <!-- Toast -->
  <transition name="toast" class="toast-leave-active">
    <Toast v-show="toast.show" v-bind:class="{'toast-wrapper' : true }" :text="toast.text"/>
  </transition>

  <section>

    <!-- Header -->
    <div class="titleBox">
      <div class="container w-100">
        <h1 >Cities Suggest Tool</h1>
      </div>
    </div>

    <!-- Content -->
    <div class="searchContainer container">
      <div class="searchBox ">

        <!--   Favorites     -->
        <Fav :toggle="isFavoritesBlockVisible" @click="toggleFavoritesBlock" />

        <!-- Search Box -->
        <div class="custom" :class="{ error: v$.searchFor.$errors.length }">
          <input v-model="v$.searchFor.$model" @keyup.enter="searchValue" v-debounce:250ms="searchValue" required minlength="3" type="search" id="search" name="search" placeholder="Enter name of a city">
          <i class="fa-solid fa-magnifying-glass input-icon"></i>
          <button @click="searchValue" id="searchButton" type="submit">Search</button>
        </div>
      </div>

      <!--  Favorites Box    -->
      <FavoriteBlock ref="getFavorites" :toggle="isFavoritesBlockVisible" v-bind:class="{'d-none' : !isFavoritesBlockVisible}" />

      <!-- Error message -->
      <div class="input-errors" v-for="(error, index) of v$.searchFor.$errors" :key="index">
        <div class="error-msg">{{ error.$message }}</div>
      </div>

      <!-- Results -->
      <div class="resultHeader">
        <h2 class="fw-bold fs-3 pb-1">Search results ({{ results.length }})</h2>
      </div>
      <div class="results">
        <div class="result" v-for="result in results">
          <button class="addButton" @click="addFavorite(result._source.geonameId, result._source.name)" title="Click to add city to favorites list">
            <i class="fa-solid fa-plus"></i>
          </button>
          <button v-clipboard="result._source.geonameId" @click="toast.trigger('ID has been copied!')" title="Click to copy ID" ><i class="fa-regular fa-copy"></i></button>
          ID: {{ result._source.geonameId }} ({{ result._source.name }} | {{ result._source.countryName }})
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import axios from "axios";
import { ref } from "vue";

import Toast from '../Toast'
import Fav from '../favorite-block/Favorite-Button'
import FavoriteBlock from "@/components/favorite-block/Favorite-Block";

import useVuelidate from '@vuelidate/core'
import { required, minLength, helpers } from '@vuelidate/validators'
import { vue3Debounce } from 'vue-debounce'

export default {
  directives: {
    debounce: vue3Debounce({ lock: true })
  },
  components: {
    Toast,
    Fav,
    FavoriteBlock,
  },
  validations() {
    return {
      searchFor: {
        required: helpers.withMessage('This field cannot be empty!', required),
        min: helpers.withMessage('Please enter more than 2 letters in order to search.', minLength(3))
      }
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      results: [],
      searchFor: '',
      isFavoritesBlockVisible: false,
      toast: {
        text: '',
        show: false,
        trigger: (text) => {
          this.toast.text = text;
          this.toast.show = true;

          setTimeout(() => {
            this.toast.show = false;
          }, 3000);
        }
      }
    };
  },
  methods: {
    searchValue() {
      const _this = this;

      if(!this.searchFor && this.searchFor.length < 3){
        return;
      }

      axios.get("http://demo.api.coin-dev.eu/api/v1/en/cities-suggest?search=" + this.searchFor)
        .then(response => {
          _this.results = response.data.data.hits.hits;
          // console.log(this.results)
          // console.log(this.searchFor)
        })
        .catch(err => {
          _this.toast.trigger('Something went wrong. Contact us if the problem persists.');
          console.error(err);
        });
    },
    toggleFavoritesBlock() {
      this.isFavoritesBlockVisible = ! this.isFavoritesBlockVisible;
    },
    async addFavorite(geonameid, name) {
      const _this = this;

      await axios.post('http://demo.api.coin-dev.eu/api/v1/en/rest/utilities/cities-favorites/add', { geonameid })
          .then(function (response) {
            // console.log(response);

            _this.toast.trigger('City has been successfully added to favorites.');
            _this.$refs.getFavorites.getFavorites();
          })
          .catch(function (error) {
            _this.toast.trigger('Something went wrong. Contact us if the problem persists.');
            console.log(error);
          });
      }
  },
}
</script>

<style lang="scss">
@import "search-block";
</style>